/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {AlertDismissService as ɵa} from './services/alert-dismiss.service';